import React, { useEffect } from 'react';
import './PrivacyPage.css';

const PrivacyMain = () => {
  useEffect(() => {
    document.body.classList.add('privacy-page');
    return () => {
      document.body.classList.remove('privacy-page');
    };
  }, []);

  return (
    <main className="privacy-plain">
      <article>
      <h1>Politique de confidentialité – Mboapass</h1>
      <p className="privacy-plain__meta">Dernière mise à jour : 19 août 2026</p>

      <h2>1. Introduction</h2>
      <p>
        Mboapass est une application mobile éditée par Mboapass, société exploitée depuis le
        Cameroun, permettant le contrôle d&apos;accès à des événements et services au moyen de la
        lecture de codes QR associés à des billets numériques.
      </p>
      <p>
        La présente Politique de confidentialité décrit les données traitées par l&apos;application,
        les finalités de leur utilisation ainsi que les mesures mises en œuvre pour protéger la vie
        privée des utilisateurs et des détenteurs de billets.
      </p>

      <h2>2. Responsable du traitement</h2>
      <p>Le responsable du traitement des données est :</p>
      <p>
        Mboapass
        <br />
        Pays d&apos;exploitation : Cameroun
        <br />
        Adresse e-mail : contract@mboapass.com
      </p>

      <h2>3. Données traitées</h2>
      <h3>3.1 Lecture des codes QR</h3>
      <p>
        L&apos;application Mboapass permet  de scanner et vérifier des codes QR
        générés par la plateforme Mboapass.
      </p>
      <p>
        Le contenu du code QR est utilisé exclusivement pour identifier et valider un billet
        numérique.
      </p>

      <h3>3.2 Informations relatives aux détenteurs de billets</h3>
      <p>
        Dans le cadre de la validation des billets, l&apos;application peut accéder aux informations
        suivantes stockées dans la plateforme Mboapass :
      </p>
      <ul>
        <li>Nom ;</li>
        <li>Prénom ;</li>
        <li>Adresse e-mail ;</li>
        <li>Numéro de téléphone ;</li>
        <li>Identifiant du billet ;</li>
        <li>Informations de validation du billet.</li>
      </ul>

      <h2>4. Finalités du traitement</h2>
      <p>Les données sont utilisées exclusivement pour :</p>
      <ul>
        <li>Vérifier l&apos;authenticité d&apos;un billet ;</li>
        <li>Autoriser ou refuser l&apos;accès à un événement ;</li>
        <li>Prévenir la fraude et la duplication de billets ;</li>
        <li>Assurer le bon fonctionnement du système de contrôle d&apos;accès ;</li>
        <li>Garantir la sécurité des opérations de validation.</li>
      </ul>
      <p>Les données ne sont utilisées à aucune fin publicitaire ou marketing.</p>

      <h2>5. Stockage temporaire sur les appareils</h2>
      <p>
        Afin d&apos;améliorer les performances de l&apos;application et de réduire les délais de
        validation, certaines informations relatives aux billets peuvent être temporairement
        conservées dans la mémoire cache de l&apos;appareil utilisé pour effectuer les contrôles.
      </p>
      <p>Ces données peuvent inclure :</p>
      <ul>
        <li>Nom ;</li>
        <li>Prénom ;</li>
        <li>Adresse e-mail ;</li>
        <li>Numéro de téléphone ;</li>
        <li>Informations de validation du billet.</li>
      </ul>
      <p>
        Ces informations sont conservées uniquement pour les besoins techniques de fonctionnement de
        l&apos;application et sont automatiquement supprimées ou remplacées lors de la mise à jour
        du cache, de la déconnexion ou de la réinstallation de l&apos;application.
      </p>

      <h2>6. Données non collectées</h2>
      <p>Mboapass :</p>
      <ul>
        <li>Ne collecte pas la géolocalisation des utilisateurs ;</li>
        <li>N&apos;accède pas aux contacts du téléphone ;</li>
        <li>N&apos;accède pas aux photos, vidéos ou fichiers personnels ;</li>
        <li>N&apos;effectue aucun suivi publicitaire ;</li>
        <li>N&apos;utilise aucun identifiant publicitaire ;</li>
        <li>Ne réalise aucun profilage comportemental ;</li>
        <li>Ne vend aucune donnée personnelle.</li>
      </ul>

      <h2>7. Partage des données</h2>
      <p>
        Les données traitées par Mboapass ne sont ni vendues, ni louées, ni cédées à des
        tiers.
      </p>
      <p>Elles peuvent uniquement être communiquées :</p>
      <ul>
        <li>Aux organisateurs d&apos;événements utilisant la plateforme Mboapass ;</li>
        <li>
          Aux prestataires techniques participant à l&apos;hébergement ou à la maintenance du
          service ;
        </li>
        <li>Aux autorités compétentes lorsque la loi l&apos;exige.</li>
      </ul>
      <p>
        Toutefois, elles peuvent être utilisées, avec modération et dans le respect de la vie
        privée, dans le cadre de campagnes publicitaires.
      </p>

      <h2>8. Sécurité des données</h2>
      <p>
        Mboapass met en œuvre des mesures techniques et organisationnelles appropriées afin de
        protéger les données contre :
      </p>
      <ul>
        <li>L&apos;accès non autorisé ;</li>
        <li>La divulgation accidentelle ;</li>
        <li>L&apos;altération ;</li>
        <li>La perte ;</li>
        <li>La destruction.</li>
      </ul>
      <p>
        Les communications entre l&apos;application et les serveurs Mboapass sont sécurisées par des
        protocoles de chiffrement adaptés (HTTPS/TLS).
      </p>

      <h2>9. Durée de conservation</h2>
      <p>
        Les données relatives aux billets et aux détenteurs de billets sont conservées sur les
        serveurs Mboapass pendant une durée maximale de 3 mois à compter de la date de
        l&apos;événement ou de l&apos;utilisation du billet.
      </p>
      <p>
        À l&apos;issue de cette période, les données sont supprimées ou anonymisées conformément aux
        besoins légaux, contractuels ou techniques applicables.
      </p>
      <p>
        Les données stockées temporairement dans le cache de l&apos;application sont supprimées
        automatiquement selon les mécanismes de gestion du cache de l&apos;application et du système
        d&apos;exploitation.
      </p>

      <h2>10. Droits des personnes concernées</h2>
      <p>Sous réserve des dispositions légales applicables, toute personne concernée peut demander :</p>
      <ul>
        <li>L&apos;accès à ses données personnelles ;</li>
        <li>La rectification de données inexactes ;</li>
        <li>La suppression de ses données ;</li>
        <li>La limitation du traitement ;</li>
        <li>Des informations complémentaires sur l&apos;utilisation de ses données.</li>
      </ul>
      <p>Toute demande peut être adressée à : contract@mboapass.com</p>

      <h2>11. Protection des enfants</h2>
      <p>Mboapass n&apos;est pas destiné spécifiquement aux enfants de moins de 13 ans.</p>
      <p>
        Toutefois, certains détenteurs de billets peuvent être des mineurs lorsque les événements
        concernés sont accessibles aux enfants.
      </p>
      <p>Dans ce cadre :</p>
      <ul>
        <li>
          Seules les données strictement nécessaires à la gestion et à la validation du billet sont
          traitées ;
        </li>
        <li>Aucune donnée n&apos;est utilisée à des fins publicitaires ou marketing ;</li>
        <li>Aucun profilage n&apos;est effectué ;</li>
        <li>Aucune donnée personnelle d&apos;enfants n&apos;est vendue ou partagée à des fins commerciales.</li>
      </ul>
      <p>
        Les parents ou représentants légaux peuvent contacter Mboapass à l&apos;adresse
        contract@mboapass.com pour toute question relative aux données concernant un mineur.
      </p>

      <h2>12. Transferts de données</h2>
      <p>
        Les données peuvent être hébergées ou traitées sur des infrastructures techniques exploitées
        par des prestataires sélectionnés par Mboapass afin d&apos;assurer la disponibilité et la
        sécurité du service.
      </p>
      <p>
        Mboapass veille à ce que tout transfert de données soit effectué dans le respect des
        exigences légales applicables en matière de protection des données.
      </p>

      <h2>13. Modifications de la présente politique</h2>
      <p>
        Mboapass se réserve le droit de modifier la présente Politique de confidentialité à tout
        moment afin de tenir compte de l&apos;évolution de ses services, des exigences
        réglementaires ou des améliorations techniques apportées à l&apos;application.
      </p>
      <p>Toute mise à jour sera publiée avec indication de la date de dernière modification.</p>

      <h2>14. Contact</h2>
      <p>
        Pour toute question relative à cette Politique de confidentialité ou à l&apos;exercice de
        vos droits :
      </p>
      <p>
        Mboapass
        <br />
        Cameroun
        <br />
        Email : contract@mboapass.com
      </p>
      </article>
    </main>
  );
};

export default PrivacyMain;
